import { Button, Dialog, Grid, CircularProgress } from '@mui/material';

interface ConfirmDialogProps {
    onConfirm: () => void | Promise<void>;
    onCancel: () => void;
    confirmText: string;
    isLoading?: boolean;
}

export const ConfirmDialog = ({ onConfirm, onCancel, confirmText, isLoading = false }: ConfirmDialogProps) => {
    return (
        <Dialog open={true} PaperProps={{ style: { padding: '40px' } }}>
            {confirmText}
            <Grid container xs={12} direction={'row'} justifyContent={'space-around'} sx={{ marginTop: '20px' }}>
                <Button variant='outlined' onClick={onCancel} disabled={isLoading}>
                    Cancel
                </Button>
                <Button variant='contained' onClick={onConfirm} disabled={isLoading}>
                    {isLoading ? <CircularProgress size={18} color='inherit' /> : 'Confirm'}
                </Button>
            </Grid>
        </Dialog>
    );
};
